import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import LatestGrid from "./components/LatestGrid";
import Topics from "./components/Topics";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { BRAND, faqPageItems, SITE_NAME } from "@/mocks/melon";

const TITLE = "实时吃瓜热搜·实时跟进全网最新瓜点 | 瓜场";
const DESCRIPTION =
  "实时吃瓜热搜，实时跟进全网最新瓜点与今日爆料。实时吃瓜最新、实时吃瓜快讯一网打尽，榜单秒级更新、信源清晰、吃瓜有度，想第一时间吃到热乎瓜就盯紧瓜场。";
const KEYWORDS = "实时吃瓜,实时吃瓜热搜,实时吃瓜最新,实时吃瓜快讯,今日热点爆料";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertJsonLd(id: string, data: unknown) {
  document.getElementById(id)?.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

function Home() {
  useEffect(() => {
    const url = `${window.location.origin}${window.location.pathname}`;

    document.title = TITLE;
    upsertMeta("name", "description", DESCRIPTION);
    upsertMeta("name", "keywords", KEYWORDS);
    upsertMeta("name", "robots", "index, follow");
    upsertMeta("name", "author", BRAND);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:title", TITLE);
    upsertMeta("property", "og:description", DESCRIPTION);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:locale", "zh_CN");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", TITLE);
    upsertMeta("name", "twitter:description", DESCRIPTION);
    upsertMeta("name", "twitter:domain", url);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    upsertJsonLd("ld-website", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      url,
      inLanguage: "zh-CN",
      publisher: { "@type": "Organization", name: BRAND },
    });

    upsertJsonLd("ld-organization", {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: BRAND,
      description: DESCRIPTION,
      url,
      email: "hello@guachang.example",
    });

    upsertJsonLd("ld-webpage", {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: TITLE,
      description: DESCRIPTION,
      url,
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", name: SITE_NAME, url },
    });

    upsertJsonLd("ld-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqPageItems.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <HotList />
        <LatestGrid />
        <Topics />
        <Guide />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default Home;